import { ElementRef, NgZone, Renderer2, DOCUMENT } from '@angular/core';
import { DomHandler } from 'prime-ng-old/dom';
import { Draggable as DraggableBase } from 'prime-ng-old/dragdrop';
import { DragDropService } from './drag-drop.service';
import { checkScopeValidity } from './helpers';
import * as i0 from "@angular/core";
import * as i1 from "./drag-drop.service";
export let Draggable = /*#__PURE__*/(() => {
  class Draggable extends DraggableBase {
    set _scope(scope) {
      checkScopeValidity(scope);
      this.scope = scope;
    }
    constructor(el, zone, renderer, document, ddService) {
      super(el, zone, renderer);
      this.el = el;
      this.zone = zone;
      this.document = document;
      this.ddService = ddService;
      this.enable = true;
      this.isBeingDragged = false;
      this.startX = null;
      this.startY = null;
      this.prevX = null;
      this.prevY = null;
      this.ghostMode = 'emulated';
    }
    mousedown(event) {
      // we need to check if the handle is related to THIS directive
      // or if there is another uiDraggable in between handle and THIS.
      const closestDraggable = event.target.matches("[draggable]") ? event.target : event.target.closest("[draggable]");
      if (closestDraggable === this.el.nativeElement) {
        this.handle = event.target;
        event.stopPropagation();
      } else {
        this.handle = null;
      }
    }
    mouseup(event) {
      this.handle = null;
    }
    // Add no host listener, parent class already has one
    // TODO: Is this wanted behaviour? https://github.com/angular/angular/issues/33632
    // @HostListener('dragstart', ['$event']) 
    dragStart(event) {
      // console.log('dragStart',this.isBeingDragged)
      if (!this.handle) return; // the event is not related to this directive
      if (!this.isBeingDragged && this.allowDrag() && !this.pDraggableDisabled) {
        this.isBeingDragged = true;
        event.stopPropagation();
        // event.preventDefault();
        if (this.dragEffect) {
          event.dataTransfer.effectAllowed = this.dragEffect;
        }
        if (this.scope) {
          event.dataTransfer.setData('text', this.scope);
          // make scope available for matching during dragging
          event.dataTransfer.setData('scope-' + this.scope, this.scope);
        }
        this.cursorOffset = {
          x: event.offsetX,
          y: event.offsetY
        };
        this.startX = this.prevX = event.clientX;
        this.startY = this.prevY = event.clientY;
        this.elementSize = {
          x: this.el.nativeElement.offsetWidth + 1,
          // +1 fixes a minor layout bug causing line breaks on clones
          y: this.el.nativeElement.offsetHeight
        };
        // trick drag API to not show a ghost (moved outside of screen)
        if (this.ghostMode !== 'native') {
          const img = this.document.createElement("img");
          event.dataTransfer.setDragImage(img, 5000, 5000);
        }
        // clone original element
        if (this.ghostMode === 'emulated') {
          if (!this.clone) this.clone = this.cloneElement();
          this.document.body.appendChild(this.clone);
        }
        this.onDragStart.emit(event);
        this.bindDragListener();
        if (this.ddService) this.ddService.beginDragging(this, event);
      } else {
        event.preventDefault();
      }
    }
    allowDrag() {
      if (this.dragHandle && this.handle) return DomHandler.matches(this.handle, this.dragHandle);else return true;
    }
    // Add no host listener, parent class already has one
    // TODO: Is this wanted behaviour? https://github.com/angular/angular/issues/33632
    // @HostListener('drag', ['$event']) 
    drag(event) {
      if (!this.handle) return; // the event is not related to this directive
      event.stopPropagation();
      if (this.ghostMode === 'emulated') {
        this.updateClonePosition(event);
      }
      event.dragOffsetX = event.clientX - this.cursorOffset.x;
      event.dragOffsetY = event.clientY - this.cursorOffset.y;
      event.draggedX = event.clientX - this.startX;
      event.draggedY = event.clientY - this.startY;
      event.deltaX = event.clientX - this.prevX;
      event.deltaY = event.clientY - this.prevY;
      this.prevX = event.clientX;
      this.prevY = event.clientY;
      this.onDrag.emit(event);
    }
    // Add no host listener, parent class already has one
    // TODO: Is this wanted behaviour? https://github.com/angular/angular/issues/33632
    // @HostListener('dragend', ['$event']) 
    dragEnd(event) {
      // console.log('dragEnd',this.handle);
      if (!this.handle) return; // the event is not related to this directive
      this.isBeingDragged = false;
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      if (this.ghostMode === 'emulated' && this.clone) {
        this.document.body.removeChild(this.clone);
        this.clone = undefined;
      }
      this.onDragEnd.emit(event);
      if (this.ddService) this.ddService.endDragging(this, event);
      this.unbindDragListener();
    }
    cloneElement() {
      const clone = this.el.nativeElement.cloneNode(true);
      const fontSize = parseFloat(getComputedStyle(this.el.nativeElement).fontSize);
      // synchronizeCssStyles(this.el.nativeElement,clone,true);
      clone.style.position = 'fixed';
      clone.style.zIndex = 9999;
      clone.style.width = this.elementSize.x + 'px';
      clone.style.height = this.elementSize.y + 'px';
      clone.style.margin = 0;
      clone.style.userSelect = 'none';
      clone.style.pointerEvents = 'none';
      clone.style.fontSize = fontSize + 'px';
      return clone;
    }
    updateClonePosition(event) {
      this.clone.style.left = event.clientX - this.cursorOffset.x + 'px';
      this.clone.style.top = event.clientY - this.cursorOffset.y + 'px';
    }
    ngOnDestroy() {
      if (this.ghostMode === 'emulated' && this.clone) {
        this.document.body.removeChild(this.clone);
        this.clone = undefined;
      }
      super.ngOnDestroy();
    }
    static {
      this.ɵfac = function Draggable_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Draggable)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i1.DragDropService, 8));
      };
    }
    static {
      this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
        type: Draggable,
        selectors: [["", "uiDraggable", ""]],
        inputs: {
          enable: [0, "uiDraggable", "enable"],
          id: [0, "uiDraggableId", "id"],
          _scope: [0, "uiDragDropScope", "_scope"],
          ghostMode: "ghostMode"
        },
        features: [i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return Draggable;
})();